<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <app-filters filtros
    [name]="'filtros.periodo' | translate"
    [array]="aniosDisponibles"
    [typeFilter]="Filters.YEAR"
    (eventClick)="yearChange($event)"
    [click]="false"
  />

  <app-filters filtros
    [name]="'filtros.pers' | translate" 
    [array]="perspectivas"
    [typeFilter]="Filters.SUCURSALES"
    [click]="false"
    [consolidado]="selectAll"
    (eventClick)="cambioPer($event)"
  />

  <div borrador>
    <mat-icon class="iconoMen" [ngStyle]="{'color':'gray'}"
      [matMenuTriggerFor]="menu2">more_vert</mat-icon>
  </div>
  <mat-menu #menu2="matMenu">
    <button (click)="exportar_excel()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
      <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
      <span>{{'menu.exportar'| translate}}</span>
    </button>
    <button (click)="ponderacionAutomatica()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
      <span>{{'gestion.formulacion.objetivos.ponderacionAutom'| translate}}</span>
    </button>
  </mat-menu>

  <div contenido class="contenidoClass">
    @if (viewTablero) {
      @for (per of perspectivas; track $index) {
        @if (mostrarPer(per)) {
          <app-contenedor-elementos class="zonaTabla" [header]="{title: per.nombre}">
            <div iconos (click)="openModalInd('indicador',per)" *appRoles="permisos.CARGA_ARCHIVOS" class="colorBotonDeNuevo">
              <mat-icon #add matTooltip="{{'gestion.formulacion.ind-metas.agregarInd'| translate}}"
              class="iconoMen">
                add_circle_outline</mat-icon>
              <label for="add">{{'gestion.formulacion.ind-metas.agregarInd'| translate}}</label>
            </div>

            <div body class="tabla">
              <table class="tabla-aleema">
                <thead>
                  <tr>
                    <th> {{'gestion.formulacion.ind-metas.tit1' | translate}} </th>
                    @if (verCodigo) {
                      <th> {{'gestion.formulacion.ind-metas.tit2' | translate}} </th>
                    }
                    <th class="sticky-column"> {{'gestion.formulacion.ind-metas.tit3' | translate}} </th>
                    <th> {{'gestion.formulacion.ind-metas.tit4' | translate}} </th>
                    <th> {{'gestion.formulacion.ind-metas.tit5' | translate}} </th>
                    <th> {{'gestion.formulacion.ind-metas.tit6' | translate}} </th>
                    <th> {{'gestion.formulacion.ind-metas.tit7' | translate}} </th>
                    <th> {{'gestion.formulacion.ind-metas.tit8' | translate}} </th>
                    @for (mes of meses; track $index) {
                      @if (indicadores.length !== 0) {
                        <th> {{mes.name}} </th>
                      }
                    }
                    <th *appRoles="permisos.CARGA_ARCHIVOS"></th>
                    @if (indicadores.length !== 0) {
                      @for (ad of diccionarioAdicionales; track $index) {
                        <th [matTooltip]="ad.name"
                        [appOverflowTooltip]="ad.name"
                        [matMenuTriggerFor]="manuEdicionAd">
                          {{ad.name}}
                        </th>
                        <mat-menu class="w3-medium" #manuEdicionAd="matMenu">
                          <button (click)="editarAdicional(ad)" class="mat-menu-item" mat-menu-item>
                            <mat-icon [ngStyle]="{'color':'gray'}">edit</mat-icon>
                            <span>{{'menu.Editar' | translate}}</span>
                          </button>
                          <button (click)="eliminarAdicional(ad)" class="mat-menu-item" mat-menu-item>
                            <mat-icon [ngStyle]="{'color':'gray'}">delete</mat-icon>
                            <span>{{'menu.eliminar' | translate}}</span>
                          </button>
                        </mat-menu>
                      }
                      <th *appRoles="permisos.CARGA_ARCHIVOS"> 
                        <mat-icon matTooltip="{{'gestion.formulacion.ind-metas.agregarAdicional'| translate}}"
                        class="iconoMen colorBotonDeNuevo" (click)="modalAdicional()">
                        add_circle_outline</mat-icon>
                      </th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (ele of indicadores; track ele; let i = $index) {
                    @if(ele.perspective === per.nombre){
                      <tr>
                        <td [matTooltip]="escribiObj(ele.objective.name,ele,i)"
                        [appOverflowTooltip]="escribiObj(ele.objective.name,ele,i)" 
                        [ngClass]="{
                          'borderCustom1': escribiObj(ele.objective.name,ele,i) == ''
                        }">
                          {{escribiObj(ele.objective.name,ele,i)}}
                        </td>
                        @if (verCodigo) {
                          <td matTooltip="{{'gestion.formulacion.ind-metas.codigo'|translate}}">
                            {{'gestion.formulacion.ind-metas.codigo'|translate}}
                          </td>
                        }                      
                        <td [matTooltip]="ele.nombre"  class="sticky-column"
                        [appOverflowTooltip]="ele.nombre">
                          {{ele.nombre}}
                        </td>
                        <td *appRoles="permisos.CARGA_ARCHIVOS" class="w3-center"
                          (dblclick)="edicionPond(ele)" style="cursor: pointer;">
                          {{ele.ponderacion===null?0:ele.ponderacion}}
                        </td>
                        <td *appRolesNeg="permisos.CARGA_ARCHIVOS" class="w3-center">
                          {{ele.ponderacion}}
                        </td>
                        <td style="max-width: 15vw;" [matTooltip]="ele.area.name"
                          [appOverflowTooltip]="ele.area.name">
                          {{ele.area.name}}
                        </td>
                        <td class="w3-center"> {{ele.linea_base}} </td>
                        <td class="w3-center"> {{ele.meta_global}} </td>
                        <td class="w3-center">{{ele.periodicidad}}</td>
                        @for (mes of meses; track $index) {
                          <td class="w3-center"> {{escrituraMet(mes.name,ele.id, ele)}} </td>
                        }
                        <td *appRoles="permisos.CARGA_ARCHIVOS" class="w3-center"> 
                          <button matTooltip="{{'gestion.formulacion.ind-metas.agregarMeta'|translate}}"
                            class="colorBotonDeNuevo" (click)="modalMeta(ele)">
                            <mat-icon class="iconoMen">add_circle_outline</mat-icon> 
                          </button>
                          <mat-icon class="iconoMen" (click)="openModalInd('editarInd',per,ele)"
                            matTooltip="{{'gestion.formulacion.ind-metas.editarInd'|translate}}" >edit</mat-icon> 
                          <mat-icon class="iconoMen" (click)="alertas('eliminar',ele)"
                            matTooltip="{{'gestion.formulacion.ind-metas.eliminarInd'|translate}}">delete</mat-icon> 
                        </td> 
                        @for (ad of ele.adicionales; track $index) {
                          <td *appRoles="permisos.CARGA_ARCHIVOS"
                            [ngStyle]="ad.type !== 'numero' && ad.type !== 'moneda'?{'cursor':'normal'}:{'cursor':'pointer'}"
                            (dblclick)="ad.type !== 'numero' && ad.type !== 'moneda'?'':editar(ad,ele.id)"> 
                            @if (ad.type === 'moneda') {
                              <span class="w3-right" style="max-width: 10vw; overflow-x: hidden;">{{imprimir(ad)}}</span>
                            }
                            @if (ad.type === 'numero') {
                              <span class="alinIzq" style="max-width: 10vw; overflow-x: hidden;">{{imprimir(ad)}}</span>
                            }
                            @if (ad.type !== 'moneda' && ad.type !== 'numero') {
                              <span style="max-width: 10vw; overflow-x: hidden;"> {{imprimir(ad)}}</span>
                            }
                          </td>
                          <td class="tresPun" *appRolesNeg="permisos.CARGA_ARCHIVOS"
                            [ngStyle]="ad.type !== 'numero' || ad.type !== 'numero'?{'cursor':'normal'}:{'cursor':'pointer'}">
                            @if(ad.type === 'moneda'){
                              <span class="w3-right" style="cursor: pointer; max-width: 10vw; overflow-x: hidden;">{{imprimir(ad)}}</span>
                            }
                            @if(ad.type === 'numero'){
                              <span class="alinIzq" style="cursor: pointer; max-width: 10vw; overflow-x: hidden;">{{imprimir(ad)}}</span>
                            }
                            @if(ad.type !== 'moneda' && ad.type !== 'numero'){
                              <span style="max-width: 10vw; overflow-x: hidden;"> {{imprimir(ad)}}</span>
                            }     
                          </td>
                        }
                        @if(indicadores.length != 0){
                          <td *appRoles="permisos.CARGA_ARCHIVOS"> </td>
                        }
                      </tr>                        
                    } 
                  }
                </tbody>
              </table>
            </div>
          </app-contenedor-elementos>
        }
      }
    }@else {
      @for (item of skeleton; track $index) {
        <div class="w3-row" style="height: 2vh; width: 98%; margin-top: 1vh;">
          <ngx-skeleton-loader count="1" [theme]="{
              'border-radius': '10px',
              height: '90%',
              width: '28%',
              margin: '4px 4px 4px 25px',
              
          }" />
        </div>
        <div class="w3-row" style="margin-top: 2vh;">
          <app-skeleton-table [columnas]="12" [filas]="3" />
        </div>
      }
    }
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="modal" [cerrar]="false" (close)="closeModal()">
  <div modal-header>
    {{titModal}}
  </div>

  <div modal-body>
    <div class="w3-row0" style="padding-left: 2vw; padding-right: 2vw;" [formGroup]="formIndicador">
      @if(verCodigo){
        <div class="form-group">
            <label for="code" class="form-label"> {{'gestion.formulacion.ind-metas.codigo' | translate}} </label>
            <input id="code" type="text" class="form-input anchosInputs" formControlName="inputCodigo" placeholder="{{'gestion.formulacion.ind-metas.codigoTT' | translate}}" required
            [matTooltip]="formIndicador.controls.inputCodigo.value" [appOverflowTooltip]="formIndicador.controls.inputCodigo.value">
        </div>
      }        
      <div class="form-group">
        <label for="nombre" class="form-label"> {{'gestion.formulacion.ind-metas.campo1' | translate}} * </label>
        <input id="nombre" type="text" class="form-input anchosInputsLarge" formControlName="inputNameInd" placeholder="{{'gestion.formulacion.ind-metas.campo1TT' | translate}}" required
        [matTooltip]="formIndicador.controls.inputNameInd.value" [appOverflowTooltip]="formIndicador.controls.inputNameInd.value">
      </div>

      <div class="form-group">
        <label for="descripcionedit" class="form-label"> {{'gestion.formulacion.ind-metas.campo2' | translate}} <span>*</span> </label>
        <input id="descripcionedit" class="form-input anchosInputsLarge" formControlName="inputDescription" placeholder="{{'gestion.formulacion.ind-metas.campo2TT' | translate}}"
        [matTooltip]="formIndicador.controls.inputDescription.value" [appOverflowTooltip]="formIndicador.controls.inputDescription.value">
      </div>

      <div class="form-group">
        <label for="calculation" class="form-label"> {{'gestion.formulacion.ind-metas.campo3' | translate}} * </label>
        <input id="calculation" type="text" class="form-input anchosInputsLarge" formControlName="inputCalculation"
        placeholder="{{'gestion.formulacion.ind-metas.campo3TT' | translate}}" required
        [matTooltip]="formIndicador.controls.inputCalculation.value" [appOverflowTooltip]="formIndicador.controls.inputCalculation.value">
      </div>

      <div class="form-group">
        <label for="objetivo" class="form-label"> {{'gestion.formulacion.ind-metas.campo4' | translate}} * </label>
        <select id="objetivo" formControlName="inputObjective" class="contentSelect anchosInputsLarge" required
        [ngClass]="{'placeholderSelect': formIndicador.controls['inputObjective'].value === 'default'}">
          <option value="default" disabled>
            {{'gestion.formulacion.ind-metas.campo4TT' | translate}}
          </option>
          @for (opt of objetivos; track $index) {
            @if (opt.perspectiveId === idPers) {
              <option class="textoOverFlow" value="{{opt.id}}"
              [matTooltip]="opt.nombre" [appOverflowTooltip]="opt.nombre">{{opt.nombre}}</option>
            }
          }
        </select>
      </div>

      <div class="zonaInputsDobles">
        <div class="form-group-mitad">
          <label for="param" class="form-label"> {{'gestion.formulacion.ind-metas.campo5' | translate}} </label>
          <input id="param" type="text" class="form-input" formControlName="inputParam" placeholder="{{'gestion.formulacion.ind-metas.campo5TT' | translate}}"
          [matTooltip]="formIndicador.controls.inputParam.value" [appOverflowTooltip]="formIndicador.controls.inputParam.value">
        </div>

        <div class="form-group-mitad">
          <label for="baseLine" class="form-label"> {{'gestion.formulacion.ind-metas.campo6' | translate}} </label>
          <input id="baseLine" type="number" class="form-input" formControlName="inputBaseLine" placeholder="{{'gestion.formulacion.ind-metas.campo5TT' | translate}}"
          [matTooltip]="formIndicador.controls.inputBaseLine.value" [appOverflowTooltip]="formIndicador.controls.inputBaseLine.value">
        </div>

        <div class="form-group-mitad">
          <label for="fechaIni" class="form-label"> {{'gestion.formulacion.ind-metas.campo7' | translate}} *</label>
          <input id="fechaIni" type="date" class="form-input" formControlName="inputFechaIn" value="{{fechaAct}}" min="{{minDate}}" max="{{maxDate}}"
              placeholder="{{'gestion.formulacion.ind-metas.campo7TT' | translate}}"
              [matTooltip]="formIndicador.controls.inputFechaIn.value" [appOverflowTooltip]="formIndicador.controls.inputFechaIn.value">
        </div>

        <div class="form-group-mitad">
          <label for="fechaFin" class="form-label"> {{'gestion.formulacion.ind-metas.campo8' | translate}} *</label>
          <input id="fechaFin" type="date" class="form-input" formControlName="inputFechaFn" min="{{formIndicador.controls['inputFechaIn'].value}}"
              placeholder="{{'gestion.formulacion.ind-metas.campo8TT' | translate}}"
              [matTooltip]="formIndicador.controls.inputFechaFn.value" [appOverflowTooltip]="formIndicador.controls.inputFechaFn.value">
        </div>

        <div class="form-group-mitad">
          <label for="globalGoal" class="form-label"> {{'gestion.formulacion.ind-metas.campo9' | translate}} * </label>
          <input id="globalGoal" type="number" class="form-input" formControlName="inputGlobalGoal" placeholder="{{'gestion.formulacion.ind-metas.campo9TT' | translate}}" required
          [matTooltip]="formIndicador.controls.inputGlobalGoal.value" [appOverflowTooltip]="formIndicador.controls.inputGlobalGoal.value">
        </div>

        <div class="form-group-mitad">
          <label for="periodicidad" class="form-label"> {{'gestion.formulacion.ind-metas.campo10' | translate}} * </label>
          <select id="periodicidad" formControlName="inputPeriodicidad" class="contentSelect" required [ngClass]="{'placeholderSelect': formIndicador.controls['inputPeriodicidad'].value === 'default'}">
            <option value="default" disabled> {{'gestion.formulacion.ind-metas.campo10TT' | translate}} </option>
            <option value="mensual">{{'gestion.formulacion.ind-metas.per1' | translate}}</option>
            <option value="bimestral">{{'gestion.formulacion.ind-metas.per2' | translate}}</option>
            <option value="trimestral">{{'gestion.formulacion.ind-metas.per3' | translate}}</option>
            <option value="cuatrimestral">{{'gestion.formulacion.ind-metas.per4' | translate}}</option>
            <option value="semestral">{{'gestion.formulacion.ind-metas.per5' | translate}}</option>
            <option value="anual">{{'gestion.formulacion.ind-metas.per6' | translate}}</option>
          </select>
        </div>

        <div class="form-group-mitad">
          <label for="unidadMedida" class="form-label"> {{'gestion.formulacion.ind-metas.campo11' | translate}} * </label>
          <select id="unidadMedida" formControlName="inputUnidadMed" class="contentSelect" required [ngClass]="{'placeholderSelect': formIndicador.controls['inputUnidadMed'].value === 'default'}">
            <option value="default" disabled> {{'gestion.formulacion.ind-metas.campo11TT' | translate}} </option>
            @for (opt of unidades_med; track $index) {
              <option value="{{opt.id}}"> {{opt.nombre}} </option>
            }
          </select>
        </div>

        <div class="form-group-mitad">
          <label for="tendencia" class="form-label"> {{'gestion.formulacion.ind-metas.campo12' | translate}} * </label>
          <select id="tendencia" formControlName="inputTendencia" class="contentSelect" required [ngClass]="{'placeholderSelect': formIndicador.controls['inputTendencia'].value === 'default'}">
            <option value="default" disabled> {{'gestion.formulacion.ind-metas.campo12TT' | translate}} </option>
            @for (opt of tenden; track $index) {
              <option value="{{opt.id}}"> {{opt.name}} </option>
            }
          </select>
        </div>

        <div class="form-group-mitad">
          <label for="area" class="form-label"> {{'gestion.formulacion.ind-metas.campo13' | translate}} * </label>
          <select id="area" formControlName="inputArea" class="contentSelect" required [ngClass]="{'placeholderSelect': formIndicador.controls['inputArea'].value === 'default'}">
            <option value="default" disabled> {{'gestion.formulacion.ind-metas.campo13TT' | translate}} </option>
            @for (opt of areas; track $index) {
              <option value="{{opt.id}}"
              [matTooltip]="opt.nombre" [appOverflowTooltip]="opt.nombre"> {{opt.nombre}} </option>
            }
          </select>
        </div>
      </div>
    </div>
  </div>  

  <app-button modal-footer
    [color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.cancel' | translate"
    (clickB)="closeModal()"
  />
  <app-button modal-footer
    [ngClass]="{'w3-disabled': formIndicador.invalid}"
    [color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.Guardar' | translate"
    (clickB)="alertas(accionModal)"
  />
</app-modal>

<app-modal [isOpen]="modal2" [cerrar]="false" (close)="closeModal()">
  <div modal-header>
    {{titModal}}
  </div>

  <div modal-body>
    <div class="w3-row w3-disabled" style="width: 98%; margin: 1vh;" [formGroup]="formIndicador">     
      <div class="w3-half" style="margin-top: 1vh !important; margin-left: 1vh; padding-right: 5%">
        <div class="txtMeta">
          <div class="w3-right zonaTxt">
            <span class="w3-right textoInputs"> {{'gestion.formulacion.ind-metas.campo1' | translate}} *</span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInputMeta">
            <input type="text" class="contentInput" formControlName="inputNameInd"
            [matTooltip]="formIndicador.controls.inputNameInd.value" [appOverflowTooltip]="formIndicador.controls.inputNameInd.value">
          </div>
        </div>
      </div>
      <div class="w3-half" style="margin-top: 1vh !important; margin-left: 1vh; padding-right: 5%">
        <div class="txtMeta">
          <div class="w3-right zonaTxt">
            <span class="w3-right textoInputs"> {{'gestion.formulacion.ind-metas.campo3' | translate}}</span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInputMeta">
            <input type="text" class="contentInput" formControlName="inputCalculation"
            [matTooltip]="formIndicador.controls.inputCalculation.value" [appOverflowTooltip]="formIndicador.controls.inputCalculation.value">
          </div>
        </div>
      </div>
      <div class="w3-half" style="margin-top: 1vh !important; margin-left: 1vh; padding-right: 5%">
        <div class="txtMeta">
          <div class="w3-right zonaTxt">
            <span class="w3-right textoInputs"> {{'gestion.formulacion.ind-metas.campo14' | translate}} *</span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInputMeta">
            <input type="text" class="contentInput" formControlName="inputDescription"
            [matTooltip]="formIndicador.controls.inputDescription.value" [appOverflowTooltip]="formIndicador.controls.inputDescription.value">
          </div>
        </div>
      </div>
      <div class="w3-half" style="margin-top: 1vh !important; margin-left: 1vh; padding-right: 5%">
        <div class="txtMeta">
          <div class="w3-right zonaTxt">
            <span class="w3-right textoInputs"> {{'gestion.formulacion.ind-metas.campo4' | translate}} *</span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInputMeta">
            <input type="text" class="contentInput" formControlName="inputObjective"
            [matTooltip]="formIndicador.controls.inputObjective.value" [appOverflowTooltip]="formIndicador.controls.inputObjective.value">
          </div>
        </div>
      </div>
      <div class="w3-half" style="margin-top: 1vh !important; margin-left: 1vh; padding-right: 5%">
        <div class="txtMeta">
          <div class="w3-right zonaTxt">
            <span class="w3-right textoInputs"> {{'gestion.formulacion.ind-metas.campo6' | translate}} *</span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInputMeta">
            <input type="number" class="contentInput" formControlName="inputBaseLine"
            [matTooltip]="formIndicador.controls.inputBaseLine.value" [appOverflowTooltip]="formIndicador.controls.inputBaseLine.value">
          </div>
        </div>
      </div>
      <div class="w3-half" style="margin-top: 1vh !important; margin-left: 1vh; padding-right: 5%">
        <div class="txtMeta">
          <div class="w3-right zonaTxt">
            <span class="w3-right textoInputs"> {{'gestion.formulacion.ind-metas.campo7' | translate}} *</span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInputMeta">
            <input type="date" class="contentDate" formControlName="inputFechaIn" value="{{fechaAct}}" min="{{minDate}}" max="{{maxDate}}" style="width: 100%;"
            [matTooltip]="formIndicador.controls.inputFechaIn.value" [appOverflowTooltip]="formIndicador.controls.inputFechaIn.value">
          </div>
        </div>
      </div>
      <div class="w3-half" style="margin-top: 1vh !important; margin-left: 1vh; padding-right: 5%">
        <div class="txtMeta">
          <div class="w3-right zonaTxt">
            <span class="w3-right textoInputs"> {{'gestion.formulacion.ind-metas.campo8' | translate}} *</span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInputMeta">
            <input type="date" class="contentDate" formControlName="inputFechaFn" value="{{formIndicador.controls['inputFechaFn'].value}}"
            min="{{formIndicador.controls['inputFechaIn'].value}}" max="{{maxDate}}" style="width: 100%;"
            [matTooltip]="formIndicador.controls.inputFechaFn.value" [appOverflowTooltip]="formIndicador.controls.inputFechaFn.value">
          </div>
        </div>
      </div>
      <div class="w3-half" style="margin-top: 1vh !important; margin-left: 1vh; padding-right: 5%">
        <div class="txtMeta">
          <div class="w3-right zonaTxt">
            <span class="w3-right textoInputs"> {{'gestion.formulacion.ind-metas.campo10' | translate}} *</span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInputMeta">
            <input type="text" class="contentInput" formControlName="inputPeriodicidad"
            [matTooltip]="formIndicador.controls.inputPeriodicidad.value" [appOverflowTooltip]="formIndicador.controls.inputPeriodicidad.value">
          </div>
        </div>          
      </div>
      <div class="w3-half" style="margin-top: 1vh !important; margin-left: 1vh; padding-right: 5%">
        <div class="txtMeta">
          <div class="w3-right zonaTxt">
            <span class="w3-right textoInputs"> {{'gestion.formulacion.ind-metas.campo12' | translate}} *</span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInputMeta">
            <input type="text" class="contentInput" formControlName="inputTendencia"
            [matTooltip]="formIndicador.controls.inputTendencia.value" [appOverflowTooltip]="formIndicador.controls.inputTendencia.value">
          </div>
        </div>          
      </div>
    </div>
    <div class="w3-row w3-tituloZonas w3-left" style="padding-left: 5%;">{{'gestion.formulacion.ind-metas.tit9' | translate}}</div>
    <div class="w3-row" style="margin-bottom: 2vh;">
      @for (met of posMet; track met; let i = $index) {
        <div class="w3-half" style="margin-top: 2vh!important;">
          <div class="w3-quarter txtMetas">
            <div class="w3-right zonaTxt" style="width: 65%;">
              <div class="w3-right textoInputs">{{met.nombre}}</div>
            </div>
            
          </div>
          <div [ngClass]="{'w3-disabled': i == posMet.length-1}" class="w3-rest" style="width: 45%;">
            <input type="number" class="contentInput" value="{{met.descripcion}}" id='{{"meta"+i}}' matInput>
          </div>
        </div>
      }
    </div>
  </div>

  <app-button modal-footer
    [color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.cancel' | translate"
    (clickB)="closeModal()"
  />
  <app-button modal-footer
    [ngClass]="{'w3-disabled':!this.formIndicador.valid}"
    [color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.Guardar' | translate"
    (clickB)="guardarMeta()"
  />
</app-modal>

<app-modal [isOpen]="modal3" [cerrar]="false" (close)="closeModal()">
  <div modal-header>
    {{titModal}}
  </div>

  <div modal-body>
    <div class="w3-row" style="width: 98%; padding-right: 1.5vw;" [formGroup]="formAdicional">
      <div class="form-group">
          <label for="nombre" class="form-label">
              {{'gestion.formulacion.ind-metas.campo15' | translate}} *
          </label>
          <input id="nombre" type="text" class="form-input" formControlName="inputName" style="min-width: 18vw;"
          [matTooltip]="formAdicional.controls.inputName.value" [appOverflowTooltip]="formAdicional.controls.inputName.value"
          placeholder="{{'gestion.formulacion.ind-metas.campo15TT' | translate}}">
      </div>
      <div class="form-group">
          <label for="select" class="form-label">
              {{'gestion.formulacion.ind-metas.campo16' | translate}}
          </label>
          <select id="select" formControlName="inputType" class="contentSelect" style="min-width: 18vw;" [ngClass]="{'placeholderSelect': formAdicional.controls['inputType'].value === ''}">
              <option value="" disabled hidden selected> {{'gestion.formulacion.ind-metas.campo16TT' | translate}} </option>
              <option value="texto" matTooltip="{{'gestion.formulacion.ind-metas.toolTipo1'}}">{{'gestion.formulacion.ind-metas.tipo1' | translate}}</option>
              <option value="moneda" matTooltip="{{'gestion.formulacion.ind-metas.toolTipo2'}}">{{'gestion.formulacion.ind-metas.tipo2' | translate}}</option>
              <option value="archivo" matTooltip="{{'gestion.formulacion.ind-metas.toolTipo3'}}">{{'gestion.formulacion.ind-metas.tipo3' | translate}}</option>
              <option value="numero" matTooltip="{{'gestion.formulacion.ind-metas.toolTipo4'}}">{{'gestion.formulacion.ind-metas.tipo4' | translate}}</option>
          </select>
      </div>
    </div>
  </div>

  <app-button modal-footer
    [color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.cancel' | translate"
    (clickB)="closeModal()"
  />
  <app-button modal-footer
    [ngClass]="{'w3-disabled':!this.formAdicional.valid}"
    [color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.Guardar' | translate"
    (clickB)="guardarAdi()"
  />
</app-modal>